import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { comics } from '@/mocks/comics';

export default function FeaturedComics() {
  const featuredComics = comics.filter((c) => c.featured).slice(0, 4);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              编辑精选推荐
            </h2>
            <p className="text-sm text-foreground-600 mt-2">精选高质量韩漫，每一部都值得细品</p>
          </div>
          <Link to="/category/all" className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop>
          {featuredComics.map((comic) => (
            <ComicCard key={comic.id} {...comic} />
          ))}
        </div>
      </div>
    </section>
  );
}